module.exports = __webpack_public_path__ + "img/5.827dbf2f.png";